<nav class="navbar" [class.scrolled]="scrolled" [class.menu-open]="menuOpen">
  <div class="container nav-inner">
    <a class="logo" routerLink="/landing-page" aria-label="FFLXCEL home" (click)="scrollToTop($event)">
      <img src="assets/images/logo/Brian%20Logo_3.svg" alt="FFLXCEL" style="height: 58px; width: auto; vertical-align: middle;">
    </a>
    <div class="nav-links">
      <button routerLink="/landing-page" (click)="scrollToTop($event)">Home</button>
      <button routerLink="/landing-page-about">About</button>
      <button routerLink="/landing-page-contact">Contact</button>
    </div>
    <div class="nav-actions">
      <button class="btn btn-small secondary" routerLink="/login">Login</button>
      @if (!hideFreeTrial) {
        <button class="btn btn-small" routerLink="/landing-page-sign-up">Free Trial</button>
      }
    </div>
    <button class="menu-toggle" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen" aria-label="Toggle navigation">
      <span></span><span></span><span></span>
    </button>
    <div class="mobile-menu" *ngIf="menuOpen">
      <button routerLink="/landing-page" (click)="scrollToTop($event)">Home</button>
      <button routerLink="/landing-page-about">About</button>
      <button routerLink="/landing-page-contact">Contact</button>
      @if (!hideFreeTrial) {
        <button class="btn" routerLink="/landing-page-sign-up">Free Trial</button>
      }
      <button class="login" routerLink="/login">Login</button>
    </div>
  </div>
</nav>
